import {
  Directive,
  Output,
  Input,
  EventEmitter,
  HostBinding,
  HostListener
} from '@angular/core';

@Directive({
  selector: '[appDnd]'
})
export class DndDirective {
  @HostBinding('class.fileover') fileOver: boolean;
  @Output() fileDropped = new EventEmitter<any>();

  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    if(this.fileOver != false){
    this.fileOver = true;
    }
    // setTimeout(() => {
    //   this.fileOver = false;
    // }, 300);
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
  }

  // Drop listener
  @HostListener('drop', ['$event']) public ondrop(evt) {
    // evt.preventDefault();
    // evt.stopPropagation();
    this.fileOver = false;
    // let files = evt.dataTransfer.files;
    // if (files.length > 0) {
    //   this.fileDropped.emit(files);
    // }
  }
}
